import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/fly.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Luca Education",
    height: "150",
    src: _imports_0,
    title: "Luca Education",
    width: "150"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-center text-neutral-500 mt-2"
}
const _hoisted_6 = {
  key: 1,
  class: "w-full mt-5"
}
const _hoisted_7 = { class: "input-group grid grid-cols-2 items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Họ và Tên ", -1)
const _hoisted_9 = {
  key: 0,
  class: "font-bold text-neutral-500 text-right"
}
const _hoisted_10 = { class: "input-group grid grid-cols-2 items-center mt-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Tuần ", -1)
const _hoisted_12 = {
  key: 0,
  class: "font-bold text-neutral-500 text-right"
}
const _hoisted_13 = {
  key: 0,
  class: "input-group grid grid-cols-2 items-center mt-10"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Ngày nộp ", -1)
const _hoisted_15 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_16 = {
  key: 1,
  class: "input-group grid grid-cols-2 items-center mt-10"
}
const _hoisted_17 = { class: "input-group__label text-neutral-500 font-normal" }
const _hoisted_18 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_19 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.successData
						? 'Báo cáo tuần đã hoàn thành'
						: 'Hoàn thành báo cáo'), 1),
      (_ctx.successData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Báo cáo này đã được lưu và bạn có thể gửi cho Phụ Huynh trong mục Báo cáo tuần "))
        : _createCommentVNode("", true),
      (!_ctx.successData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              (_ctx.reportData?.student)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.reportData.student), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              (_ctx.reportData?.week_start)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(`${_ctx.$filters.toWeek(
								_ctx.reportData.week_start,
								true
							)} (${_ctx.$filters.formatDate2(
								_ctx.reportData.week_start
							)} - ${_ctx.$filters.endWeek(_ctx.reportData.week_start)})`), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.reportData?.report_date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$filters.formatDate2(_ctx.reportData.report_date)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.reportData?.staff)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$filters.terminology('teacher')) + " làm báo cáo ", 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.reportData.staff), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _toDisplayString(_ctx.successData ? 'Đóng' : 'Quay lại'), 1),
      (!_ctx.successData)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button-p text-center whitespace-nowrap",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " Xác nhận "))
        : _createCommentVNode("", true)
    ])
  ]))
}